import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';
import { Spinner } from '@/shared/ui/spinner';

type OAuthWaitingViewProps = { providerName: string; onCancel: () => void };

export function OAuthWaitingView({ providerName, onCancel }: OAuthWaitingViewProps) {
  return (
    <>
      <span data-enter="">
        <BadgeIcon>
          <Spinner size="lg" />
        </BadgeIcon>
      </span>
      <div data-enter="" className="flex flex-col gap-2" aria-live="polite">
        <h1 className="font-semibold text-title-lg">Continuing with {providerName}</h1>
        <p className="text-muted">
          Finish in the {providerName} window. This page moves on by itself when you are signed in.
        </p>
      </div>
      <p data-enter="" className="text-meta text-muted">
        <Button variant="link" size="inline" onClick={onCancel}>
          Cancel and go back
        </Button>
      </p>
    </>
  );
}
